import { render, staticRenderFns } from "./CoachMetricsStub.vue?vue&type=template&id=1e2fed6d&"
import script from "./CoachMetricsStub.vue?vue&type=script&setup=true&lang=js&"
export * from "./CoachMetricsStub.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports